export const LEGAL = {
  privacy: {
    label: "Privacy",
    title: "Privacy Statement",
    updated: "Last observed · 25 July 2026",
    intro:
      "Sybils Society is a conceptual, art-directed experience. Even so, when you join the Outer Circle, request an Audience, or consult the Oracle, you entrust us with information. We hold it with the same discretion we ask of our initiates.",
    sections: [
      {
        h: "What we gather",
        p: "Outer Circle (waitlist): your name, email, and optional field of power. The Sybils Assessment (Mysteries application): your name, email, and your long-form answers. The Oracle: any intention you type and the archetype/statement drawn for you. The Gate: a Sigil access key and a session token stored in your browser to keep you within the Sanctum.",
      },
      {
        h: "How we use it",
        p: "To respond to your interest, to review applications and grant provisional passage, to generate your personalized oracle statement, and to maintain your authenticated session. We do not sell your information, and we do not use it for advertising.",
      },
      {
        h: "AI processing",
        p: "Oracle statements are generated by a third-party large-language-model provider. The intention text you submit is transmitted to that provider solely to produce your statement. Do not enter sensitive personal, medical, financial, or confidential information into the Oracle.",
      },
      {
        h: "Storage & retention",
        p: "Records are stored in our database for as long as needed to operate the experience. Your Sigil is stored only as an irreversible hash — we cannot read it back. Your session token lives in your browser's local storage and is removed when you seal the veil behind you (log out).",
      },
      {
        h: "Your rights",
        p: "You may request access to, correction of, or deletion of the information you have given us. Where required by law, you may also object to or restrict certain processing. Reach us using the contact below and we will respond within a reasonable time.",
      },
      {
        h: "Security",
        p: "We use industry-standard measures — hashed credentials, signed session tokens, and access controls. No system is perfectly secure, and we cannot guarantee absolute security, but we treat your trust as sacred.",
      },
      {
        h: "Contact",
        p: "Direct all privacy matters to the Oracles at privacy@sybils.council.",
      },
    ],
  },
  terms: {
    label: "Terms",
    title: "Terms of Service",
    updated: "Last observed · 25 July 2026",
    intro:
      "By entering Sybils Society — the Outer Veil, the Gate, the Mysteries, or the Inner Sanctum — you accept these terms. If you do not agree, do not proceed past the Veil.",
    sections: [
      {
        h: "A conceptual experience",
        p: "Sybils Society: The Return of the Matriarchs is a creative, narrative, and artistic experience. Its 'secret society,' tiers, relics, and rituals are symbolic. Nothing here constitutes a real membership organization, security, investment vehicle, or political body.",
      },
      {
        h: "The Sigil & access",
        p: "A Sigil is a personal access key. Keep it confidential; you are responsible for activity under your Sigil. We may revoke access, decline applications, or withdraw passage at our sole and unreviewable discretion — admission is never guaranteed.",
      },
      {
        h: "The Oath is symbolic",
        p: "The Oath, sealed 'in blood-intention,' is a narrative act. It creates no legally binding obligation of confidentiality, non-competition, or otherwise. It is honored as art, not enforced as contract.",
      },
      {
        h: "Not professional advice",
        p: "Oracle statements, manifesto texts, and any guidance are for inspiration and entertainment only. They are not financial, legal, medical, psychological, or professional advice. Make consequential decisions with qualified counsel.",
      },
      {
        h: "Intellectual property",
        p: "All brand marks, text, imagery, 3D scenes, and code are owned by Sybils or its licensors. You may not copy, resell, or create derivative works without written permission. Content you submit remains yours, but you grant us a license to use it to operate the experience.",
      },
      {
        h: "Acceptable conduct",
        p: "Do not attempt to breach the Gate, probe our systems, submit unlawful or harmful content, impersonate others, or disrupt the experience for other initiates.",
      },
      {
        h: "Disclaimers & liability",
        p: "The experience is provided 'as is,' without warranties of any kind. To the fullest extent permitted by law, Sybils is not liable for indirect, incidental, or consequential damages arising from your use of the experience.",
      },
      {
        h: "Changes & contact",
        p: "We may revise these terms; continued use signifies acceptance. Questions may be sent to the Oracles at council@sybils.council.",
      },
    ],
  },
  accessibility: {
    label: "Accessibility",
    title: "Accessibility Statement",
    updated: "Last observed · 25 July 2026",
    intro:
      "Sybils Society is deeply immersive, and we believe wonder should be shared widely. We are committed to making this experience as usable as possible for as many people as possible.",
    sections: [
      {
        h: "Our aim",
        p: "We strive to align with the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA as a target. Accessibility is an ongoing practice, not a finished state.",
      },
      {
        h: "What we do",
        p: "Semantic structure and landmarks, keyboard-operable controls and forms, clear focus states, descriptive alternative text on imagery, and considered color contrast for body text against the obsidian background.",
      },
      {
        h: "Motion & reduced motion",
        p: "We honor your system 'reduce motion' preference: when enabled, interface animations, pulsing glows, and smooth-scroll momentum are minimized. The 3D scenes remain part of the art direction but are decorative — all information and actions are available without them.",
      },
      {
        h: "Known limitations",
        p: "This is a WebGL-rich experience. On older devices or without hardware acceleration, 3D scenes may be heavy or degrade gracefully. Some ornamental glyphs are marked decorative and hidden from assistive technology.",
      },
      {
        h: "Alternatives & feedback",
        p: "If any part of Sybils Society is a barrier for you, tell us and we will provide the information or complete the action another way. Write to the Oracles at access@sybils.council and we will respond promptly.",
      },
    ],
  },
};

export const LEGAL_ORDER = ["privacy", "terms", "accessibility"];
